import { c as _c } from "react/compiler-runtime";
import { Form, Tooltip } from '@onefootprint/ui';
import type { VerificationCheckFormValues } from '../../../verification-check.types';
export type TooltipToggleProps = {
  name: keyof Pick<VerificationCheckFormValues, 'kyb' | 'einOnly' | 'businessAml' | 'kyc' | 'sentilink' | 'neuroId' | 'baselayer' | 'baselayerEinOnly'>;
  disabledTooltipText?: string;
  canEdit: boolean;
  label: string;
  hint: string;
};
const TooltipToggle = t0 => {
  const $ = _c(9);
  const {
    name,
    disabledTooltipText,
    canEdit,
    label,
    hint
  } = t0;
  const t1 = !disabledTooltipText;
  const t2 = !canEdit || !!disabledTooltipText;
  let t3;
  if ($[0] !== hint || $[1] !== label || $[2] !== name || $[3] !== t2) {
    t3 = <Form.Toggle name={name} label={label} hint={hint} size="compact" disabled={t2} />;
    $[0] = hint;
    $[1] = label;
    $[2] = name;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== disabledTooltipText || $[6] !== t1 || $[7] !== t3) {
    t4 = <Tooltip disabled={t1} content={disabledTooltipText}>{t3}</Tooltip>;
    $[5] = disabledTooltipText;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default TooltipToggle;